Ext.define('SA.VectorMapExportDeliveryOptionsWindow', {
    alias: 'widget.vector-map-export-delivery-options-window',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-vector-map-export-delivery-options-window',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    initComponent() {
        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-vector-map-export-delivery-options-window-header',

                items: [
                    {
                        xtype: 'component',
                        html: 'Export Map \u2013 Export'
                    }, {
                        xtype: 'close-button'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-vector-map-export-delivery-options-window-body',

                items: [
                    {
                        xtype: 'simple-container',
                        cls: 'sa-vector-map-export-delivery-options-window-field-row',

                        items: [
                            {
                                xtype: 'component',
                                cls: 'sa-vector-map-export-delivery-options-window-field-label',
                                html: 'File format:'
                            }, {
                                xtype: 'sa-radio-group',
                                itemId: 'fileFormatRadioGroup',
                                ariaLabel: 'File format',

                                items: [
                                    {value: 'png', boxLabel: 'PNG', checked: true},
                                    {value: 'jpeg', boxLabel: 'JPEG'},
                                    {value: 'pdf', boxLabel: 'PDF'}
                                ]
                            }
                        ]
                    }, {
                        xtype: 'simple-container',
                        cls: 'sa-vector-map-export-delivery-options-window-field-row',
                        margin: '17 0 18 0',

                        items: [
                            {
                                xtype: 'component',
                                cls: 'sa-vector-map-export-delivery-options-window-field-label',
                                html: 'Export to:'
                            }, {
                                xtype: 'sa-toggle-switch',
                                checked: true,
                                cls: 'sa-vector-map-export-delivery-options-window-email-or-save-toggle-switch',
                                itemId: 'emailOrSaveToggle',
                                leftText: 'Email',
                                rightText: 'Save to computer'
                            }
                        ]
                    }, {
                        xtype: 'simple-container',
                        itemId: 'emailSection',

                        items: [
                            {
                                xtype: 'simple-container',
                                cls: 'sa-vector-map-export-delivery-options-window-field-row',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-vector-map-export-delivery-options-window-field-label',
                                        html: 'Email address:'
                                    }, {
                                        xtype: 'sa-textfield',
                                        allowBlank: false,
                                        itemId: 'emailAddress',
                                        msgTarget: 'none',
                                        vtype: 'email',
                                        width: 262,
                                        value: SA.User.getEmailAddress()
                                    }
                                ]
                            }, {
                                xtype: 'simple-container',
                                cls: 'sa-vector-map-export-delivery-options-window-field-row',
                                margin: '11 0 0 0',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-vector-map-export-delivery-options-window-field-label',
                                        html: 'Message:<br>(optional)'
                                    }, {
                                        xtype: 'textarea',
                                        itemId: 'emailMessage',
                                        width: 262
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-vector-map-export-delivery-options-window-footer',

                items: [
                    {
                        xtype: 'sa-button',
                        itemId: 'returnToLayoutButton',
                        text: 'Return to Layout'
                    }, {
                        xtype: 'sa-button',
                        itemId: 'finishedButton',
                        padding: '0 18',
                        text: 'Finished',
                        ui: 'primary'
                    }, {
                        xtype: 'sa-button',
                        action: 'cancelMapExport',
                        text: 'Cancel'
                    }
                ]
            }
        ];

        this.callParent();

        this.fileFormatRadioGroup = this.down('#fileFormatRadioGroup');
        this.emailOrSaveToggle = this.down('#emailOrSaveToggle');
        this.emailSection = this.down('#emailSection');
        this.addressField = this.down('#emailAddress');
        this.messageField = this.down('#emailMessage');
        this.finishedButton = this.down('#finishedButton');
    },

    beforeRender() {
        this.callParent();

        this.refresh();
    },

    getEmailParams() {
        var address = this.addressField.getValue(),
            message = this.messageField.getValue();

        return {address, message};
    },

    getExtension() {
        return this.fileFormatRadioGroup.getValue();
    },

    initEvents() {
        this.callParent();

        this.emailOrSaveToggle.on('change', this.refresh, this);
        this.addressField.on('change', this.refresh, this);
    },

    isEmailChecked() {
        return !this.emailOrSaveToggle.isChecked();
    },

    refresh() {
        var byEmail = this.isEmailChecked(),
            addressField = this.addressField;

        addressField.setDisabled(!byEmail);
        this.messageField.setDisabled(!byEmail);

        this.emailSection.setVisible(byEmail);

        this.finishedButton.setDisabled(byEmail && !addressField.isValid());
    }
});